import { z } from "zod";
import { GENERATION_RATIOS } from "../../../Board/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

const zExpandSettings = z.object({
  prompt: z.string().nullable().default(null),
  num_generations: z.number().default(4),
  generation_ratio: z.enum(GENERATION_RATIOS).default("r_1_1"),
});

export const expandSettingsStorage = settingsStorageFactory(
  "expand-settings",
  2,
  zExpandSettings,
);
